import { KeyType } from 'hooks/useHighlightContext'

export function getHighlightsPattern(isMatch: boolean, hlKey: KeyType) {
  return new RegExp(isMatch && hlKey ? `^${hlKey}` : `^${hlKey || ''}$`)
}

export function splitName(name: string): string[] {
  return name.split('.')
}

export function isField(name: string): boolean {
  return name.includes('field')
}
